import styled from '@emotion/styled';
import { ClassAttributes, createElement } from 'react';

interface Props {
  inverse?: boolean;
  className?: string;
}

const Logo = ({ inverse = false, className }: ClassAttributes<SVGElement> & Props) => (
  <Root viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" className={className}>
    <rect id="Rectangle-path" x="-0.5" y="24" fill={inverse ? '#fff' : '#4C566C'} width="30.1" height="6" />
    <path
      id="Shape_1_"
      fill="#2DD28D"
      d="M26.5,0h-6v3h3.9L10.8,16.6l1.2,1.2L-0.4,5.4v4.2l11.3,11.2l2.1-2.1l0,0L26.5,5.2V9h3V3V0
      H26.5z"
    />
  </Root>
);

const Root = styled('svg')({ width: 32, height: 'auto' });

export default Logo;
